<template>
  <b-card class="my-2">
    <b-card-header class="card-header-results border-0 d-flex justify-content-between">
      <div class="card-header-result-label border-0 d-flex align-items-center">
        <b-button-group size="sm" class="mr-3" v-if="showBook">
          <b-icon
          variant="primary"
          :icon="collapsed ? 'dash-square' : 'plus-square'"
          v-b-toggle.accordion-1
          v-b-tooltip.hover :title="$gettext('Expand')"
          @click="toggleCollapse()"
          />
          <b-icon icon="info-square"  variant="info" class="mx-1" v-b-tooltip.hover :title="$gettext('View more')" @click="$emit('info')"/>
          <b-iconstack  variant="danger"  v-b-tooltip.hover :title="$gettext('Select PDF')" @click="$emit('toggle')">
            <b-icon icon="square" stacked />
            <b-icon icon="check" v-if="selected" scale="0.7" stacked />
          </b-iconstack>
        </b-button-group>
        <div  class="header-title">
          <strong v-if="labelPart1">{{ labelPart1 }}</strong>
        </div>
      </div>
      <div class="d-flex justify-items-right">
        <div>
            <span class="header-date">{{ formatDate(result.date) }}</span>
            <span v-if="result.isBookable && result.isAvailable" class="FCAVL ml-2" v-b-tooltip.hover :title="$gettext('Available')">
              <b-icon icon="check-circle" font-scale="1.1"></b-icon>
            </span>
            <span v-else-if="result.isBookable" class="RQNA ml-2" v-b-tooltip.hover :title="$gettext('On Request')">
              <b-icon icon="chat-quote" font-scale="1.1"></b-icon>
            </span>
        </div>
        <div class="price-and-status" @click="$emit('priceDetails')">
          <span class="price-off"><span v-translate>Price</span> : {{ result.gross }} EUR</span>
        </div>
      </div>
    </b-card-header>
    <b-card-body v-if="collapsed" class="pb-0">
      <b-row>
        <b-col md="3">
           <b-carousel
            id="carousel"
            controls
            indicators
            v-if="result.images && result.images.length">
            <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="imageIndex">
              <template slot="img">
                <img :src="image" class="img-fluid w-100 d-block carousel-img"/>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <img v-else src="@/assets/images/bg.jpg" class="img-fluid" />
        </b-col>
        <b-col md="9" class="transport-info pl-4">
          <b-row class="mb-3">
            <b-col sm="5" class="align-items-center" :class="!result.location_name ? 'hidden' : ' ' ">
              <h6 class="location-title py-2">
                <b-icon icon="geo-alt" />&nbsp;
                <translate>location</translate>:&nbsp;&nbsp;<span class="text-uppercase">{{ result.location_name }}</span>
              </h6>
            </b-col>
            <b-col sm="7">
              <div class="y-responsive">
                <b-table-simple responsive class="table table-sm date-table mb-0">
                  <b-tbody>
                    <template  v-for="(date, dateIndex) in result.dates"   >
                      <tr v-if="!datesCollapsed || date.date === result.date" :key="'date' + dateIndex">
                        <td>
                          <span v-if="showDatesCollapse && (datesCollapsed || !dateIndex)">
                            <b-icon
                            class="text-success border-success"
                            :icon="!datesCollapsed ? 'dash-square' : 'plus-square'"
                            @click="datesCollapsed = !datesCollapsed"
                            />
                          </span>
                          <span v-else class="px-1">&nbsp;</span>
                        </td>
                        <td :class="{
                          'font-weight-bold': !datesCollapsed && (date.date == result.date)
                        }">{{ formatDate(date.date) }}</td>
                        <td>
                          <span v-if="date.isBookable && date.isAvailable" class="FCAVL"><b-icon icon="check-circle"/></span>
                          <span v-else-if="date.isBookable" class="RQNA"><b-icon icon="chat-quote"/></span>
                          <span v-else class="RQNA"><b-icon icon="slash-circle"/></span>
                        </td>
                        <td>
                          <b-btn
                            size="sm"
                            variant="warning"
                            type="button"
                            class="float-right my-0 py-0"
                            @click="$emit('book')"
                            v-if="showBook && date.isBookable"
                          >
                            {{ date.isAvailable ? $gettext('Book') : $gettext('On Request') }}
                          </b-btn>
                        </td>
                      </tr>
                    </template>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
          </b-row>
          <span>
            {{ result.description }}
          </span>
        </b-col>
        <template v-if="showWebDescriptions">
          <b-col sm="12" v-for="(desc, index) in result.web_descriptions" :key="'desc' + index" class="py-1 mt-2">
            <h6>{{ desc.label}}</h6>
            <div v-html="desc.text"></div>
          </b-col>
        </template>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    result: {
      type: Object,
      required: true
    },
    showWebDescriptions: {
      type: Boolean,
      default: false
    },
    showBook: {
      type: Boolean,
      default: true
    },
    selected: Boolean,
    expanded: Boolean
  },
  data () {
    return {
      collapsed: this.expanded,
      datesCollapsed: true
    }
  },
  computed: {
    showDatesCollapse () { return this.result.dates.length > 1 },
    splitLabel () { return this.result.label.split('/') },
    labelPart1 () {
      return (this.splitLabel.length > 0) ? this.splitLabel[0] : ''
    },
    labelPart2 () {
      return (this.splitLabel.length > 1) ? this.splitLabel[1] : ''
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    formatDate (date) {
      return moment(date, 'DD-MM-YYYY').format('ddd, DD MM YYYY')
    }
  }
}
</script>

<style lang="scss">
  .transport-info{
    white-space: pre-line;
  }
  .text-uppercase{
    text-transform: uppercase;
  }
  .hidden{
    visibility: hidden!important;
  }
  .header-date{
    display: inline-block;
    padding-top: 0.25rem;
    color:#05205d;
    margin-right:.5rem;
  }
  .date-table{
    color:#05205d;
    td {
      border-top:2px solid #05205d;
      border-bottom:2px solid #05205d;
      padding: .4rem;
    }
  }

  .location-title {
    color:#05205d;
    border-top:2px solid #05205d;
    border-bottom:2px solid #05205d;
    padding: .4rem;
  }

  .y-responsive {
    max-height:200px;
    padding:0px;
    overflow:scroll;

    &:hover{
      box-shadow: 0px 1px 1px rgba(0,0,0,.25);
      cursor: pointer;
    }
  }
  .header-title {
    display: inline-block;
    line-height: 1.5rem;
    strong {
      display: block;
    }
  }

.card-header-results {
  padding: 3px 3px 3px 10px !important;
  border:1px solid rgba(0,0,0,.125);
}
.card-header-results .price-and-status{
  padding: .25rem;
  text-align: right;
  color:#f04e23;
}
.card-header-result-name {
  cursor: pointer;
  border-bottom: 1px solid rgba(0,0,0,.25);
  padding-bottom: 5px;
}
</style>
